//import React from 'react'
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import React, { useState, useEffect } from "react";
import { useSession } from "../SessionContext";
import axios from "axios";
import { API_URL } from "../../config";
import { uploads } from "../../config";

const DoctorContactDetailsForm = () => {
    const { session } = useSession();
    const [show, setShow] = useState(true);
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [preview, setPreview] = useState("");

    // ✅ GET USER PERSONAL DETAILS
    useEffect(() => {
        axios
            .get(`${API_URL}/api-get-user-details.php`, {
                withCredentials: true,
            })
            .then((res) => {
                const user = res.data.data[0];
                setData(user);
                setFormData(user); // ✅ IMPORTANT: sync editable state
                
                // ✅ Set image preview dynamically
                if (user.business_logo) {
                    setPreview(`${uploads}/${user.business_logo}`);
                }
            })
            .catch((err) => console.log(err));
    }, []);

    // ✅ UPDATE API CALL
    const handleSave = () => {
        const isValid = validate();

        if (!isValid) {
            return; // ❌ STOP HERE if invalid
        }

        const payload = {
            user_id: session?.userid,
            business_address: formData.business_address,
            business_city: formData.business_city,
            business_district: formData.business_district,
            business_state: formData.business_state,
            business_zipcode: formData.business_zipcode,
            business_contactno1: formData.business_contactno1,
            business_contactno2: formData.business_contactno2,
            business_whatsappno: formData.business_whatsappno,
        };

        axios.post(
            `${API_URL}/api-update-contact-details.php`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }
        )
            .then((res) => {
                alert("Updated Successfully!");

                setData(formData); // update UI
                setShow(true); // switch back to view mode
            })
            .catch((err) => {
                console.log(err);
                alert("Update Failed!");
            });
    };

    function changeState() {
        setShow(!show);
    }

    // ✅ FORM VALIDATIONS
    const validate = () => {
        let newErrors = {};

        if (!formData.business_address?.trim()) {
            newErrors.business_address = "Address is required";
        }

        if (!formData.business_city?.trim()) {
            newErrors.business_city = "City is required";
        }

        if (!formData.business_district?.trim()) {
            newErrors.business_district = "District is required";
        }

        if (!formData.business_state?.trim()) {
            newErrors.business_state = "State is required";
        }

        if (!formData.business_zipcode) {
            newErrors.business_zipcode = "Zipcode is required";
        } else if (!/^\d{6}$/.test(formData.business_zipcode)) {
            newErrors.business_zipcode = "Zipcode must be 6 digits";
        }

        if (!formData.business_contactno1) {
            newErrors.business_contactno1 = "Contact No. 1 is required";
        } else if (!/^\d{10}$/.test(formData.business_contactno1)) {
            newErrors.business_contactno1 = "Enter valid 10-digit number";
        }

        if (!formData.business_whatsappno) {
            newErrors.business_whatsappno = "Whatsapp number is required";
        } else if (!/^\d{10}$/.test(formData.business_whatsappno)) {
            newErrors.business_whatsappno = "Enter valid 10-digit number";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div className='bd-right-panel fade-in'>
            <p style={{ display: "none" }}>User ID: {session?.userid} | Category: {session?.ucategory} | Email: {session?.email}</p>

            <div className='comp-details'>
                <div className='logo-box'>
                    <img src={preview || "/images/default-profile-pic.jpg"} className="fullimg" alt={data.business_fullname}
                    onError={(e) => {
                        e.target.onerror = null; // prevent infinite loop
                        e.target.src = "/images/default-profile-pic.jpg";
                    }} />
                </div>
                <div className='title-box'><VerifiedIcon /> {data?.user_first_name || ""} {data?.user_middle_name || ""} {data?.user_last_name || ""}</div>
                <div className='location-box'>
                    <FmdGoodOutlinedIcon />
                    {data?.business_address ? `${data.business_address}, ` : ""}
                    {data?.business_city ? `${data.business_city}, ` : ""}
                    {data?.business_district ? `${data.business_district}, ` : ""}
                    {data?.business_state ? `${data.business_state} - ` : ""}
                    {data?.business_zipcode || ""}
                </div>
            </div>
            <div className='clr'></div>
            <div className='devider'></div>
            <div className='db-form-panel'>
                <div className='heading'>
                    <h2>Business Contact Details:</h2>
                    {show ? (
                        <div className='edit-btnbox' onClick={changeState} ><EditIcon /> Edit</div>
                    ) : (
                        <div className='close-btnbox' onClick={changeState} ><CloseIcon /> Close</div>
                    )}
                    <div className='clr'></div>
                </div>
                {show ? (
                    <div className='db-form-details'>
                        <div className='row'>
                            <div className='col-md-8'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Address" value={data?.business_address || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="City" value={data?.business_city || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="District" value={data?.business_district || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="State" value={data?.business_state || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Zip Code" value={data?.business_zipcode || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Contact No. 1" value={data?.business_contactno1 || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Contact No. 2" value={data?.business_contactno2 || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Whatsapp No." value={data?.business_whatsappno || ""} /></div></div>
                        </div>
                    </div>
                ) : (
                    <div className='db-form-details'>
                        <div className='row'>
                            <div className='col-md-8'><div className='db-form-row'><TextField className="db-textbox" label="Address*" value={formData.business_address || ""} onChange={(e) => setFormData({ ...formData, business_address: e.target.value })} error={!!errors.business_address} helperText={errors.business_address} /> </div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField className="db-textbox" label="City*" value={formData.business_city || ""} onChange={(e) => setFormData({ ...formData, business_city: e.target.value })} error={!!errors.business_city} helperText={errors.business_city} /> </div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField className="db-textbox" label="District*" value={formData.business_district || ""} onChange={(e) => setFormData({ ...formData, business_district: e.target.value })} error={!!errors.business_district} helperText={errors.business_district} /> </div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField className="db-textbox" label="State*" value={formData.business_state || ""} onChange={(e) => setFormData({ ...formData, business_state: e.target.value })} error={!!errors.business_state} helperText={errors.business_state} /> </div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField className="db-textbox" label="Zipcode*" value={formData.business_zipcode || ""} onChange={(e) => setFormData({ ...formData, business_zipcode: e.target.value })} error={!!errors.business_zipcode} helperText={errors.business_zipcode} /> </div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField className="db-textbox" label="Contact No. 1*" value={formData.business_contactno1 || ""} onChange={(e) => setFormData({ ...formData, business_contactno1: e.target.value })} error={!!errors.business_contactno1} helperText={errors.business_contactno1} /> </div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField className="db-textbox" label="Contact No. 2 (Optional)" value={formData.business_contactno2 || ""} onChange={(e) => setFormData({ ...formData, business_contactno2: e.target.value })} /> </div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField className='db-textbox' label="Whatsapp No.*" value={formData?.business_whatsappno || ""} onChange={(e) => setFormData({ ...formData, business_whatsappno: e.target.value })} error={!!errors.business_whatsappno} helperText={errors.business_whatsappno} /></div></div>
                            <div className='col-md-12'>
                                <div className='db-form-row'>
                                    <div style={{ textAlign: "center" }}>
                                        <button onClick={handleSave} className="update-btn">
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default DoctorContactDetailsForm
